import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { MeetingService } from 'src/app/service/meeting.service';
import { SideNavServiceService } from 'src/app/service/side-nav-service.service';
import { WebsocketTransferService } from 'src/app/service/websocket-transfer.service';

@Component({
  selector: 'app-create-meeting',
  templateUrl: './create-meeting.component.html',
  styleUrls: ['./create-meeting.component.css']
})
export class CreateMeetingComponent implements OnInit {
  listOfOptions: any;
  isLoading : boolean = false;
  meetingData: any; 
  templateNames:any;
  existMeetingId:any;
  categoryType: any = <any>[];
  spinner:any;
  searchText:any;
  private readonly notifier!: NotifierService;
  constructor(notifierService: NotifierService,private dialog: MatDialog, private router: Router, private webTranService: WebsocketTransferService, private meetingService: MeetingService, private sideNav: SideNavServiceService, @Inject(MAT_DIALOG_DATA) data: any) {
    //this.meetingData = data['response'];
    var categoryReq = {"orgCode":localStorage.getItem("orgCode"),"userId":localStorage.getItem("userId")};
    this.meetingService.loadCategory(categoryReq).subscribe(response => {
        this.categoryType = response.body;
      });
    this.existMeetingId = data['meetingId'];
    
    this.notifier = notifierService;
  }

  ngOnInit(): void {
    this.isLoading=true;
    var categoryReq = {"orgCode":localStorage.getItem("orgCode"),"userId":localStorage.getItem("userId"),"fkCategory":0};
    this.meetingService.getTemplateNameByCategory(categoryReq).subscribe((templateName:any)=>{
 
      this.templateNames=templateName.body;
        this.isLoading = false;
    });
    // this.listOfOptions = this.typesOfTemplate.map((listName: any) => {
    //   return listName['key_name']
    // })
    
  }

  updateSelection(categoryId: any) {
  this.searchText='';
    this.isLoading=true;
 
    var categoryReq = {"orgCode":localStorage.getItem("orgCode"),"userId":localStorage.getItem("userId"),"fkCategory":categoryId};
    this.meetingService.getTemplateNameByCategory(categoryReq).subscribe((templateName:any)=>{
 
      this.templateNames=templateName.body;
        this.isLoading = false;
    });
    //this.selectedTemplate = template
  }

  startMeeting() {
    //

    var jsonObj = {
      "meetingId": 43841,
      "userId": localStorage.getItem("userId")
    }
    this.meetingService.startMeeting(jsonObj).subscribe((meetingRes: any) => {
      //
      this.sideNav.openInstantMeeting(true);
      var reqJson = { "meetingId": 43841, "userId": localStorage.getItem("userId"), "loggedStatus": "LOGIN" }
      this.webTranService.pushUserLoggedInStatus(43841, reqJson).subscribe((data) => {
      });
      this.router.navigate(['schedule'], { queryParams: { "meetingResult": JSON.stringify({ "meetingId": 43841 }) }, skipLocationChange: true, replaceUrl: false });
    },
      err => {
        //
      });
    this.dialog.closeAll()
  }
  meetingDetails(template:any) {
    var reqJSON={"templateName":template,"meetingId":this.existMeetingId, "orgCode":localStorage.getItem("orgCode"),"userId":localStorage.getItem("userId")};
    
    this.spinner=true;
    this.meetingService.loadTemplate(reqJSON).subscribe((responseObj:any)=>{
      
      this.router.navigate(['schedule'], { queryParams: { "meetingResult": JSON.stringify( {"meetingId" : this.existMeetingId }) }, skipLocationChange: true, replaceUrl: false });  
      this.dialog.closeAll();
  }).add(()=>{
    this.spinner=false;
    //this.notifier.notify("success","Template loaded successfully");
  });


  }
  searchTemplateText(event : any){
    this.searchText = event.target.value
  }
  searchTemplateName(data:any){
    this.isLoading=true;
 
    var reqJSON={
      "templateName":data,
      "orgCode":localStorage.getItem("orgCode"),
      "userId":localStorage.getItem("userId")
    };
    this.meetingService.getTemplateNameByCategory(reqJSON).subscribe((templateName:any)=>{
 
      this.templateNames=templateName.body;
        this.isLoading = false;
    });
  /*this.meetingService.searchTemplate(reqJSON).subscribe((responseObj:any)=>{
 
    this.templateNames=responseObj.body;
    this.isLoading=false;
  });*/
}
}
